import { formatPrismicData } from '@monofront/business/utils';
import { IDeliveryFeesTableProps } from './types';

export const mapDeliveryFeesValuesTable = ({
  prismicContent,
}): IDeliveryFeesTableProps => {
  return formatPrismicData(prismicContent);
};
